import styled from "@emotion/styled";

import type { ContentSchemaRenderProps } from "~/components/content/content-schema-render";

import type { ExtraProps } from "./scmp-youtube";

import { Iframe as ContentSchemaRenderIframe } from ".";

export function useContentSchemaRenderIframe() {
  const withExtraProps = (extraProps: ExtraProps) => {
    const Component = (p: ContentSchemaRenderProps) => (
      <ContentSchemaRenderIframe {...p} {...extraProps} />
    );
    return styled(Component)``;
  };

  return {
    withExtraProps,
  };
}
